import { ApplicationEventType } from '../constants';
import { GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { GATrackingEventPayload } from '~shared/modules/ga-tracking/models';
import { EventWithLabel } from '~shared/modules/seo/constants';

export class CategoryCardClickApplicationEvent {
  type = ApplicationEventType.CategoryCardClick;

  constructor(private payload: EventWithLabel) {}

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.CategoryCardClick,
      label: this.payload.label,
    };
  }
}
